export enum TagTheme {
    THEME_0 = 'theme-0',
    THEME_1 = 'theme-1',
    THEME_2 = 'theme-2',
    THEME_3 = 'theme-3',
    THEME_4 = 'theme-4',
    THEME_5 = 'theme-5',
    THEME_6 = 'theme-6',
    THEME_7 = 'theme-7',
    THEME_8 = 'theme-8',
    THEME_9 = 'theme-9',
    THEME_10 = 'theme-10',
    THEME_11 = 'theme-11',
}

export const getThemesForDisplay = (): TagTheme[] => Object.values(TagTheme).slice(1, 11);
